import { DeleteOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ReactElement, ReactNode, memo } from "react";
import {
  ApplicationBankGuardStatus,
  ApplicationBankStatus,
} from "../../../../../utils/guards/ApplicationBankStatusGuard/types";
import { Guard } from "../../../../../utils/guards/Guard";

import classes from "../../DocForAgent/style/DocRequestList.module.css";

interface IDocIcons {
  Tag?: ReactNode;
  loadingDocument: boolean;
  isDocBolean: boolean;
  isDocSigned: boolean;
  status?: ApplicationBankStatus;
  allowedStatuses: ApplicationBankGuardStatus[];
  deleteDocument: () => void;
}

function DocIcons(props: IDocIcons): ReactElement {
  const {
    isDocBolean,
    loadingDocument,
    deleteDocument,
    Tag,
    status,
    allowedStatuses,
  } = props;

  function onDelete() {
    deleteDocument();
  }

  return (
    <div className={classes.iconWrapper}>
      {Tag}
      <Guard.ApplicationBankStatus
        status={status}
        allowedStatuses={allowedStatuses}
      >
        <Button
          loading={loadingDocument}
          data-cy={"button-delete-document-icons"}
          type="link"
          icon={<DeleteOutlined style={{ color: "red" }} />}
          onClick={onDelete}
          disabled={!isDocBolean}
        ></Button>
      </Guard.ApplicationBankStatus>
    </div>
  );
}

export default memo(DocIcons);
